module.exports = __webpack_public_path__ + "img/section4_img5.ee90a088.svg";